import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: "rgba(102, 87, 142, 1)", // Your main color
        },
    },
    components: {
        MuiAppBar: {
            styleOverrides: {
                root: {
                    minHeight: "42px !important",
                    height: "42px !important",
                    padding: "0px !important",
                },
            },
        },
        MuiToolbar: {
            styleOverrides: {
                root: {
                    minHeight: "42px !important",
                    height: "42px !important",
                    paddingLeft: "16px !important",
                    paddingRight: "16px !important",
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    padding: '6px',
                },
                head: {
                    backgroundColor: "rgba(102, 87, 142, 1)", // Apply to table headers
                    color: "#fff", // Make text white for contrast
                },
            },
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    height: '40px',
                },
            },
        },
        MuiIconButton: {
            styleOverrides: {
                root: {
                    padding: '4px',
                },
            },
        },
        MuiSvgIcon: {
            styleOverrides: {
                root: {
                    fontSize: '18px',
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: "none", // Keep text capitalization normal
                    fontWeight: 600,
                },
                containedPrimary: {
                    backgroundColor: "rgba(102, 87, 142, 1)", // Apply main color to buttons
                    "&:hover": {
                        backgroundColor: "rgba(82, 67, 122, 1)", // Darker shade on hover
                    },
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    padding: "2rem",
                    backgroundColor: "#fff",
                },
            },
        },
        MuiMenu: {
            styleOverrides: {
              paper: {
                padding: "4px 0px", // Reduce overall padding inside the menu
              },
            },
          },
          MuiMenuItem: {
            styleOverrides: {
              root: {
                padding: "4px 12px", // Reduce padding for individual menu items
                minHeight: "32px", // Make items more compact
              },
            },
          },
        //   MuiOutlinedInput: {
        //     styleOverrides: {
        //       input: {
        //         // Increase padding so autofill doesn’t fill the entire area
        //         padding: "16px",
        //         // Force the autofill background to respect content-box
        //         "&:-webkit-autofill": {
        //           backgroundClip: "content-box !important",
        //         },
        //       },
        //     },
        //   },
          MuiTableSortLabel: {
            styleOverrides: {
              root: {
                color: "white !important", // Ensures all column names remain white
                "&:hover": {
                  color: "white", // Keeps the color white on hover
                },
                "&.Mui-active": {
                  color: "white !important", // Ensures active (sorted) column stays white
                },
              },
              icon: {
                color: "white !important", // Ensures sorting arrow is also white
              },
            },
          },
    },
});

export default theme;